import { requestQuoteSchema } from 'store/schemas/database.schemas';
import { normalize } from 'normalizr';
import RequestHotelRoomsRepository from 'services/repositories/RequestHotelRoomsRepository';
import { buildRequestQuotesByRequestIdSelector } from 'store/selectors/requestQuotes.selector';
import { putDatabase } from '../actions/database.actions';

export function saveRequestHotelRoomPictures(requestHotelRoomId, hotelRoomPicturesIds)
{
    return async (dispatch, getState) =>
    {
        const requestQuotesRepository = new RequestHotelRoomsRepository();
        const result = await requestQuotesRepository.saveRequestHotelRoomPictures(requestHotelRoomId, { hotelRoomPicturesIds });

        if (!result.isSuccess())
        {
            return;
        }

        const requestQuotesSelector = buildRequestQuotesByRequestIdSelector();
        const { requestHotel, requestHotelRoomPictures } = result.response;
        const requestQuotes = requestQuotesSelector(getState(), requestHotel.request_id);

        const parsedComponents = requestQuotes.map((requestQuote) =>
        {
            const requestQuoteComponents = requestQuote.requestQuoteComponents.map((requestQuoteComponent) =>
            {
                if (requestQuoteComponent.component_type !== 'Hotel')
                {
                    return requestQuoteComponent;
                }

                const updatedHotelRooms = requestQuoteComponent.requestComponent.requestHotelRooms.map((requestHotelRoom) =>
                {
                    if (requestHotelRoom.id === requestHotelRoomId)
                    {
                        return { ...requestHotelRoom, requestHotelRoomPictures };
                    }

                    return requestHotelRoom;
                });

                return { ...requestQuoteComponent, requestComponent: { ...requestQuoteComponent.requestComponent, requestHotelRooms: updatedHotelRooms } };
            });

            return { ...requestQuote, requestQuoteComponents };
        });

        const n = normalize(parsedComponents, [requestQuoteSchema]);
        dispatch(putDatabase(n.entities));
    };
}
